<template>
  <el-dialog :close-on-click-modal="false" :show="show" :visible="visible" style="text-align:center" title="自建库配煤" width="75%"
             @close="close">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="detail-form-content" label-width="120px">
      <el-form-item class="input" label="到场地" prop="portName">
        <el-select v-model="ruleForm.portName"  placeholder="港口名称" @change="changePort">
          <el-option v-for="item in portList" :value="item.portName" :label="item.portName" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="input" label="目标热值" prop="targetHots">
        <el-input v-model.number="ruleForm.targetHots" autocomplete="off" placeholder="目标热值"></el-input>
      </el-form-item>
      <el-form-item class="input" label="目标硫分" prop="targetLiufen">
        <el-input v-model="ruleForm.targetLiufen" autocomplete="off" placeholder="目标硫分"></el-input>
      </el-form-item>
      <el-form-item class="input" label="目标吨数" prop="totalCount">
        <el-input v-model.number="ruleForm.totalCount" autocomplete="off" placeholder="目标吨数"></el-input>
      </el-form-item>
      <el-form-item class="input" label="最大煤泥占比" prop="maxMnWeight">
        <el-input v-model.number="ruleForm.maxMnWeight" autocomplete="off" placeholder="最大煤泥占比"></el-input>
      </el-form-item>
      <el-collapse v-model="activeNames">
        <el-collapse-item :disabled="!disabled" name="2" title="自建库煤源">
          <el-table :data="ownerDataList" border height="400px" style="width: 100%"
                    @selection-change="selectOwnerListMethod">
            <el-table-column
                align="center"
                header-align="center"
                type="selection"
                width="50">
            </el-table-column>
            <el-table-column fixed label="索引" type="index" width="50"></el-table-column>
            <el-table-column align="center" fixed label="煤炭名称" prop="cocalName" width="200"></el-table-column>
            <el-table-column align="center" fixed label="调用（吨）" width="200">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.useWeight" :controls="false" size="min"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column align="center" fixed label="联系人" prop="personName1"></el-table-column>
            <el-table-column align="center" fixed label="煤种类型" prop="cocalType"></el-table-column>
            <el-table-column align="center" label="热值" prop="hots" sortable="custom"></el-table-column>
            <el-table-column align="center" label="硫分" prop="liufen"></el-table-column>
            <el-table-column align="center" label="含税单价" prop="unitPrice" sortable="custom"
                             width="130"></el-table-column>
            <el-table-column align="center" label="库存" prop="stock"></el-table-column>
            <el-table-column align="center" label="到场地" prop="arriveStation"></el-table-column>
            <el-table-column align="center" label="含税运费" prop="hsPrice" sortable="custom"
                             width="100"></el-table-column>
            <el-table-column align="center" label="场地费" prop="stationPrice" sortable="custom"
                             width="90"></el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item :disabled="!disabled" name="1" title="系统煤源">
          <el-table :data="dataList" border height="400px" style="width: 100%"
                    @selection-change="selectionChangeHandler">
            <el-table-column
                align="center"
                header-align="center"
                type="selection"
                width="50">
            </el-table-column>
            <el-table-column fixed label="索引" type="index" width="50"/>
            <el-table-column align="center" fixed label="煤炭名称" prop="cocalName" width="200"></el-table-column>
            <el-table-column align="center" fixed label="联系人" prop="personName1"></el-table-column>
            <el-table-column align="center" fixed label="联系电话" prop="mobile1"></el-table-column>
            <el-table-column align="center" fixed label="煤种类型" prop="cocalType"></el-table-column>
            <el-table-column align="center" label="热值" prop="hots" sortable="custom"></el-table-column>
            <el-table-column align="center" label="硫分" prop="liufen"></el-table-column>
            <el-table-column align="center" label="含税单价" prop="unitPrice" sortable="custom" width="130"></el-table-column>
            <el-table-column align="center" label="是否破碎" prop="isBroken"></el-table-column>
            <el-table-column align="center" label="库存" prop="stock"></el-table-column>
            <el-table-column align="center" label="到场地" prop="arriveStation"></el-table-column>
            <el-table-column align="center" label="含税运费" prop="hsPrice" sortable="custom"
                             width="100"></el-table-column>
            <el-table-column align="center" label="场地费" prop="stationPrice" sortable="custom"
                             width="90"></el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>

      <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
        <el-button class="btn" type="primary" @click="commit()">提交</el-button>
        <el-button class="btn close" @click="close()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import base from '../../../utils/base'

export default {
  name: 'portOwnerMatchAdd',
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.show) {
        window.vm = this;
        this.initPortList();
      }
    },
  },
  data() {
    var validateTotalCount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入数字'));
      }
      setTimeout(() => {
        if (!Number.isNaN(value) && value % 100 === 0) {
          callback();
        } else {
          callback(new Error('请输入100的倍数'));
        }
      }, 100);
    };
    var validateNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入数字'));
      }
      setTimeout(() => {
        if (!Number.isNaN(value) && /^-?\d+(\.\d+)?$/.test(value)) {
          callback();
        } else {
          callback(new Error('请输入有效的数字或小数'));
        }
      }, 100);
    };
    return {
      disabled: false,
      url: base.get().url,
      visible: false,
      ruleForm: {
        portName: '',
        targetHots: '',
        targetLiufen: '',
        totalCount: '',
      },
      portList: [],
      rules: {
        portName: [{required: true, message: '请选择港口名称', trigger: 'blur'}],
        targetHots: [{required: true, message: '请输入目标热值', trigger: 'blur'},
          {type: 'number', message: '请输入数字', trigger: 'blur'}
        ],
        targetLiufen: [{required: true, message: '请输入硫分', trigger: 'blur'},
          {validator: validateNumber, trigger: 'blur'}
        ],
        totalCount: [{required: true, message: '请输入目标吨数', trigger: 'blur'},
          {validator: validateTotalCount, trigger: 'blur'}
        ],

      },
      selectSystemList: [],
      dataList: [],
      ownerDataList: [],
      selectOwnerList: [],
      activeNames: [],
    }
  },
  methods: {
    close() {
      this.$refs['ruleForm'].resetFields();
      this.$emit("listenToChildEvent", false);
      this.activeNames = [];
    },
    parseWeight(useWeight, totalCount) {
      let weight = (useWeight / totalCount) * 100;
      return weight | 0;
    },
    commit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let totalCount = this.ruleForm.totalCount;
          if (this.selectOwnerList.length <= 0) {
            this.$message.warning("请选择自建库煤源！");
            this.activeNames = ['2'];
            return;
          }
          let weight = 0;
          let selectOwnCocals = '';
          let selectOwnWeightCocals = '';
          let selectSystemCocalIds = '';
          this.selectOwnerList.map(item => {
            if (item.useWeight === undefined) {
              selectOwnCocals += item.id + ",";
            } else {
              if (item.useWeight > totalCount) {
                this.$message.warning("您输入的调运量超过总调运量，请调整");
                return;
              }
              if (item.useWeight > item.stock) {
                this.$message.warning("您输入的调运量超过自建库库存，请调整");
                return;
              }
              let cocalWeight = this.parseWeight(item.useWeight, totalCount);
              if (cocalWeight < 5) {
                this.$message.warning("您输入自建库调运量低于最低要求，请调整");
              }
              weight += cocalWeight;
              let str = item.id + ":" + cocalWeight + ",";
              selectOwnWeightCocals += str;
            }

          })
          selectOwnCocals = selectOwnCocals.substring(0, selectOwnCocals.length - 1);
          selectOwnWeightCocals = selectOwnWeightCocals.substring(0, selectOwnWeightCocals.length - 1);
          if (weight > 90) {
            this.$message.warning("自建库煤源占比已超过最大限度，请调整！");
            this.activeNames = ['2'];
            return;
          }
          console.log(selectOwnWeightCocals);
          if (selectOwnWeightCocals.split(",").length > 3) {
            this.$message.warning("自建库输入条数过多请调整！");
            this.activeNames = ['2'];
            return;
          }

          let systemListStr = '';
          this.selectSystemList.map(item => {
            let str = item.id + ",";
            systemListStr += str;
          })
          this.ruleForm.selectSystemCocalIds = systemListStr;
          this.ruleForm.selectOwnCocals = selectOwnCocals;
          this.ruleForm.selectOwnWeightCocals = selectOwnWeightCocals;
          let loading = this.$loading({
            lock: true,
            text: '计算中，请稍候.....',
            background: 'rgba(0,0,0,0.5)'
          });
          this.ruleForm.matchType = '自建库配煤';
          if (this.ruleForm.maxMnWeight === '' || this.ruleForm.maxMnWeight == null) {
            this.ruleForm.maxMnWeight = 100;
          }
          this.$http({
            url: this.url + `portMatchResult/` + "saveOwner",
            method: "post",
            data: this.ruleForm
          }).then(({data}) => {
            loading.close();
            if (data && data.code === 0) {
              this.$message({
                message: data.msg,
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.close();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    // 多选
    selectionChangeHandler(val) {
      this.selectSystemList = val;
    },

    selectOwnerListMethod(val) {
      this.selectOwnerList = val;
    },
    //获取系统煤源
    getSystemCocalList(portName) {
      let result = {'portName': portName};
      this.$http({
        url: "cocalTemplate/getCoalListByPortParams/",
        method: "get",
        params: result
      }).then(({data}) => {
        this.dataList = data.data;
      });
    },
    //获取自建库煤源
    getOwnerCocalList(portName) {
      let result = {'portName': portName};
      this.$http({
        url: "cocalTemplateOwner/getCoalListByPortParams/",
        method: "get",
        params: result
      }).then(({data}) => {
        this.ownerDataList = data.data;
      });
    },
    changePort() {
      if (this.ruleForm.portName === '') {
        this.disabled = false;
        this.ruleForm.selectSystemCocalIds = '';
        this.ruleForm.selectOwnCocals = '';
        this.ruleForm.selectOwnWeightCocals = '';
      } else {
        this.disabled = true;
        this.getOwnerCocalList(this.ruleForm.portName);
        this.getSystemCocalList(this.ruleForm.portName);
      }
    },
    initPortList() {
      this.$http({
        url:  this.url+`port/`+"list",
        method: "get",
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.portList = data.data;
        } else {
          this.$message.error(data.msg);
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-form-item__label {
  font-weight: bold
}

.el-collapse-item__header {
  font-size: 18px
}
</style>